// src/layouts/scattered-media/scattered-media.tsx
import Richtext from "@a24/ui/Richtext";
import SanityImage from "@a24/ui/SanityImage";
import Title from "@a24/ui/Title";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useRef, useState } from "react";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
gsap.registerPlugin(ScrollTrigger);
var ScatteredMedia = ({
  className = "",
  description,
  id,
  images,
  title
}) => {
  const [isIn, setIsIn] = useState(false);
  const wrapperRef = useRef(null);
  const hasContent = description && title && images;
  useGSAP(() => {
    ScrollTrigger.create({
      trigger: wrapperRef.current,
      start: "top 50%",
      onEnter: () => {
        setIsIn(true);
      },
      onLeaveBack: () => {
        setIsIn(false);
      }
    });
  });
  return hasContent ? /* @__PURE__ */ jsxs(
    "div",
    {
      className: `${className} full-viewport-width h-256 relative flex items-center justify-center flex-col`,
      ref: wrapperRef,
      id,
      children: [
        title && /* @__PURE__ */ jsx(
          Title,
          {
            text: title,
            className: "heading-lg pb-14 w-[100%] px-6 md:px-0 md:w-161 text-center"
          }
        ),
        description && /* @__PURE__ */ jsx(
          Richtext,
          {
            className: "freetext-richtext body-lg w-[100%] px-6 md:px-0 md:w-110 text-center",
            text: description
          }
        ),
        images && /* @__PURE__ */ jsxs(Fragment, { children: [
          images[0] && /* @__PURE__ */ jsx(
            SanityImage,
            {
              className: "absolute left-[calc(50%-11.6875rem)] top-3 md:left-[calc(50%-43.4375rem)] md:top-[calc(50%-29rem)] w-[8.9375rem] h-auto md:w-[12.5rem] rounded-sm overflow-hidden",
              sanityImageSourceData: images[0].image,
              width: 200,
              height: 300
            }
          ),
          images[1] && /* @__PURE__ */ jsx(
            SanityImage,
            {
              className: "absolute left-[calc(50%-1.25rem)] top-[calc(50%-30.75rem)] md:left-[calc(50%+0.8125rem)] md:top-[calc(50%-30.75rem)] w-[14.25rem] h-auto md:w-[20.0625rem] hidden md:block rounded-sm overflow-hidden",
              sanityImageSourceData: images[1].image,
              width: 321,
              height: 214
            }
          ),
          images[2] && /* @__PURE__ */ jsx(
            SanityImage,
            {
              className: "absolute left-[calc(50%-1.25rem)] top-11 md:left-[calc(50%+29.0625rem)] md:top-[calc(50%-8.4375rem)] w-[14.0625rem] h-auto md:w-[16.9375rem] rounded-sm overflow-hidden",
              sanityImageSourceData: images[2].image,
              width: 271,
              height: 181
            }
          ),
          images[3] && /* @__PURE__ */ jsx(
            SanityImage,
            {
              className: "absolute  left-[calc(50%-10.5rem)] bottom-17 md:bottom-auto md:left-[calc(50%-39.5rem)] md:top-[calc(50%+6.875rem)] w-[9rem] h-auto md:w-[19.25rem] rounded-sm overflow-hidden",
              sanityImageSourceData: images[3].image,
              width: 308,
              height: 385
            }
          ),
          images[4] && /* @__PURE__ */ jsx(
            SanityImage,
            {
              className: "absolute  left-[calc(50%)] top-[calc(50%+18.5625rem)] md:left-[calc(50%-8.8125rem)] md:top-[calc(50%+18.6875rem)] w-[11.1875rem] h-auto md:w-[15rem] hidden md:block rounded-sm overflow-hidden",
              sanityImageSourceData: images[4].image,
              width: 240,
              height: 300
            }
          ),
          images[5] && /* @__PURE__ */ jsx(
            SanityImage,
            {
              className: "absolute left-[calc(50%)] bottom-3 md:left-[calc(50%+21.3125rem)] md:bottom-auto md:top-[calc(50%+13.1875rem)] w-[10.5rem] h-auto md:w-[22.3125rem] rounded-sm overflow-hidden",
              sanityImageSourceData: images[5].image,
              width: 357,
              height: 238
            }
          )
        ] })
      ]
    }
  ) : /* @__PURE__ */ jsx(Fragment, {});
};
var scattered_media_default = ScatteredMedia;

export {
  scattered_media_default
};
